import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_edit",
  "use": "icon-icon_edit-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-icon_edit\"><path d=\"M10 10a.5.5 0 1 1 0 1H2a.5.5 0 1 1 0-1h8ZM6.707 2.672l2.121 2.12-4.242 4.244H2.464V6.914l4.243-4.242Zm2.12-1.416 1.417 1.417a.499.499 0 0 1 0 .705l-.708.708-2.122-2.122.708-.708a.499.499 0 0 1 .705 0Z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol